import React, { useEffect, useState } from "react";
import app from "../firestore";

export const AuthContext = React.createContext();

export const AuthProvider = ({ children }) => {
    const [currentUser, setCurrentUser] = useState({
        user: null,
        pending: true
    });

    useEffect(() => {
        app.auth().onAuthStateChanged((user) => {
            setCurrentUser({
                user: user,
                pending: false
            })
        });
    }, []);

    return (
        <AuthContext.Provider
            value={
                [currentUser, setCurrentUser]
            }
        >
            {children}
        </AuthContext.Provider>
    );
};